var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNextArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.182,
    height: 14.121,
    viewBox: "0 0 9.182 14.121",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nextarrow",
    d: "M0,12,6,6,0,0",
    transform: "translate(1.061 1.061)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "3px"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNextArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/next-arrow.8066dc6183cc68c9906a48228c2787ab.svg";